const options = {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  timeZoneName: "short",
};

/**
 * Timestamp handling function.
 *
 * convertTimestamp(timestamp) returns date in YYYY-MM-DD format
 *
 * convertTimestamp(timestamp, { includeTime: true }) returns date and time in YYYY-MM-DDTHH:MM:SSZ format
 *
 * convertTimestamp(timestamp, { includeTime: true, localization: "fi-FI" }) returns date and time in DD.MM.YYYY klo HH.MM.SS format
 *
 * convertTimestamp(timestamp, { includeTime: false, localization: "fi-FI" }) returns date and time in DD.MM.YYYY format
 *
 * @param {Date|string} timestamp
 * @param {{ includeTime: boolean, localization: string }} options
 * @returns
 */
const convertTimestamp = (timestamp, options = null) => {
  if (!timestamp) {
    return "";
  }

  var result = new Date(timestamp);

  if (!options.localization && options.includeTime && options.offset) {
    return convertUTCToOffset(result, options.offset);
  }

  if (!options || Object.keys(options).length === 0) {
    return result.toISOString();
  }

  if (options.localization) {
    result = result.toLocaleString(options.localization);
  } else {
    result = result.toISOString();
  }

  if (!options.includeTime) {
    result = result.split("T")[0].split(" ")[0];
  }

  return "" + result;
};

/**
 *
 * @param {Date} utcDate
 * @param {integer} offsetHours
 * @returns YYYY-MM-DDTHH:MM:SS±02:00
 */
const convertUTCToOffset = (utcDate, offsetHours) => {
  const utc = utcDate.getTime();
  const local = new Date(utc + offsetHours * 3600000);

  // format ISO string without trailing Z
  const iso = local.toISOString().slice(0, -1);

  // build offset part (+02:00 / -05:00, etc.)
  const sign = offsetHours >= 0 ? "+" : "-";
  const abs = String(Math.abs(offsetHours)).padStart(2, "0");

  return `${iso}${sign}${abs}:00`;
};

/**
 *
 * @param {Date|string} timestamp
 * @returns DD.MM.YYYY klo HH.MM.SS
 */
const convertTimestampWithTime = (timestamp) =>
  convertTimestamp(timestamp, {
    includeTime: true,
    // localization: "fi-FI",
    offset: 2,
  });

/**
 *
 * @param {Date|string} timestamp
 * @returns DD.MM.YYYY
 */
const convertTimestampNoTime = (timestamp) =>
  convertTimestamp(timestamp, {
    includeTime: false,
    // localization: "fi-FI",
  });

/**
 *
 * @param {Date|string} timestamp
 * @returns YYY-MM-DD HH:MM:SS
 */
const convertTimestampLocalized = (timestamp) =>
  convertTimestamp(timestamp, {
    includeTime: true,
    localization: "sv-SE", // sv-SE starts with YYYY-MM-DD so looks better than fi-FI
  });

export {
  convertTimestamp,
  convertTimestampNoTime,
  convertTimestampWithTime,
  convertTimestampLocalized,
};
